import {Injectable} from "@angular/core";
import {AlertController, LoadingController, ToastController} from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { tap, map, catchError } from "rxjs/operators";


@Injectable()
export class GeneralServices implements HttpInterceptor{
	
	private loader;
	isLoading: boolean = false;

	constructor(private alertCtrl: AlertController, private loadingCtrl: LoadingController, private translate: TranslateService,public toastController: ToastController) {
		
	}

	intercept(req: HttpRequest<any>,next:HttpHandler): Observable<HttpEvent<any>>{
		this.presentLoading();
		return next.handle(req).pipe(
            map((event: HttpEvent<any>) => {
              if (event instanceof HttpResponse) {
                // Cerramos el loading en el fin de la llamada
                this.dismissLoading();
              }
              return event;
            }),
            catchError((error: HttpErrorResponse) => {
              console.error(error);
              this.dismissLoading();
              // Presentamos un toast con el mensaje de error
             // this.presentErrorToast('Ups, ha habido un problema');
              return throwError(error);
            })
          );
		
	}

	getFormatedTime(dateString){
		var date = new Date(dateString);
		var hours = date.getHours();
		var am_pm = date.getHours() >= 12 ? "pm" : "am";
		var minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
		let	formatHours = hours < 10 ? "0" + hours : hours;
		let time = formatHours + ":" + minutes;
		return time;
	 }


	async errorManager(error:any,_loader:any,IsDataResult:boolean){
		
		if(_loader != ''){
			try{
				_loader.dismiss();
			}catch(e){}
		}
		
		let alerta;

		if(IsDataResult){
			alerta = await this.alertCtrl.create({
		            header: "ERROR!!!",
		            subHeader: error,
		            buttons: ['OK']
		          });
				  await  alerta.present();	
		}else{
			
			alerta = await this.alertCtrl.create({
			            header: "ERROR!!!",
			            subHeader: error.statusText,
			            buttons: ['OK']
			          });
					  await  alerta.present();	
		}
	}


	setLanguage(translate){
		     
			let lang=localStorage.getItem("App_Idioma");
			 
			if(lang == null){
				lang='es';
			}
			translate.setDefaultLang(lang);
			translate.use(lang);
		
	}

	async presentToast(message:string) {
    const toast = await this.toastController.create({
      message: message,
      duration: 2000
    });
    toast.present();
  }
	
	async toastNotify(message:any,type:string){
				
		let alerta;

		
		alerta = await  this.alertCtrl.create({
				header: (type=='success')?"MENSAJE":"ERROR!!!",
				subHeader: message,
				buttons: ['OK']
				});
		await alerta.present();	
		
	}

	 showLoading(stringKey: string, AdittionalText?: string){
		
		/*if(AdittionalText == undefined){
			AdittionalText = '';
		}
		let _thisClass=this;
		*/
		 this.loader.present();
	}

	hideLoading(){
		if(this.loader != undefined){
			this.loader.dismiss();
		}
	}


	async presentLoading() {
		this.isLoading = true;
		return await this.loadingCtrl.create({
		  duration: 5000,
		}).then(a => {
		  a.present().then(() => {
			if (!this.isLoading) {
			  a.dismiss().then(() => console.log());
			}
		  });
		});
	  }
	  async dismissLoading() {
		this.isLoading = false;
		return await this.loadingCtrl.dismiss().then(() => console.log('dismissed'));
		}
		
		rellenarCero(number,width){
			var numberOutput = Math.abs(number); /* Valor absoluto del número */
			var length = number.toString().length; /* Largo del número */ 
			var zero = "0"; /* String de cero */  
			
			if (width <= length) {
					if (number < 0) {
							 return ("-" + numberOutput.toString()); 
					} else {
							 return numberOutput.toString(); 
					}
			} else {
					if (number < 0) {
							return ("-" + (zero.repeat(width - length)) + numberOutput.toString()); 
					} else {
							return ((zero.repeat(width - length)) + numberOutput.toString()); 
					}
			}
	}
	

}